import React from "react";
import { NavLink } from "react-router-dom";
import Header4 from "./../Common/Header4";
import Banner from "./../Elements/Banner";
import { productsDetails } from "../../data";
import Footer2 from "../Common/Footer2";

var bnrimg = require("./../../images/page_banners/Banner1.JPEG");

class ShopList extends React.Component {
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner title="Rental Page" pagename="Rental Page" bgimage={bnrimg} />
          {/* SHOP SECTION START */}
          <div className="section-full p-t120 p-b90 bg-cream mobile-page-padding">
            <div className="container">
              {/* <div className="product-filter-wrap d-flex justify-content-between align-items-center m-b30">
                <div className="list-grid-control">
                  <NavLink to={"/rentals"}>
                    <i className="fa fa-th" />
                  </NavLink>
                  <NavLink to={"/rentals-list"} className="active">
                    <i className="fa fa-th-list" />
                  </NavLink>
                </div>
              </div> */}
              <div className="text-center clearfix filter-pos-right shadow m-b30">
                <ul className="btn-filter-wrap">
                  <h4 className="mb-0">
                    For prices please{" "}
                    <NavLink to={"/contact-us"}>Contact us</NavLink>{" "}
                  </h4>
                </ul>
              </div>
              <div className="row d-flex justify-content-center">
                <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
                  <div className="shop-item-list-wrap-outer">
                    {productsDetails.map((item, index) => (
                      <div key={index} className="shop-item-list-wrap m-b30">
                        <div className="sx-box sx-product-box   overflow-hide">
                          <div className="sx-thum-bx sx-img-overlay1">
                            <img src={item.image} alt="" />
                          </div>
                          <div className="sx-info">
                            <h5 className="sx-title">{item.title}</h5>
                            <p className="mb-2">{item.description}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* SHOP SECTION END */}
        </div>

        <Footer2 />
      </>
    );
  }
}

export default ShopList;
